export enum AgencyTypes {
    IATA = 1,
    NoIATA = 2,
    ReactivateIATA = 3,
    IATAprimerIngreso = 4,
    CambioRepresentanteYAdmin = 5,
}